import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractCustomerComponent } from '@df/account/v2/abstract-customer.component';
import { isCardExpired } from '@df/checkout/util/is-card-expired';
import { Address } from '@df/session/api/address-book/address';
import { CreditCard } from '@df/session/api/credit-cards/credit-card';
import { HistoryOrder } from '@df/session/api/history/history-order';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { Section2Component } from '../../ui/display/section2/section2.component';
import { AccountGreetingComponent } from '../greeting/account-greeting.component';
import { AccountNavigationComponent } from '../navigation/account-navigation.component';
declare module '@df/session/customer/customer.interfaces' {
    namespace Customer {
        interface ICustomerData {
            prefix?: string;
            dob?: string;
            preferred_store?: number;
        }
    }
}
declare module '@df/account/account.interfaces' {
    namespace Account {
        interface IEditFormData {
            prefix?: string;
            dob?: string;
            preferred_store?: number;
        }
    }
}
@Component({
    selector: 'account-dashboard',
    templateUrl: './account-dashboard.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, Section2Component, AccountGreetingComponent, AccountNavigationComponent, GridModule, RouterLink]
})
export class AccountDashboardComponent extends AbstractCustomerComponent implements OnInit, OnDestroy {
    lastOrder?: HistoryOrder;
    customerName?: string;
    firstAddress?: Address;
    defaultCard?: CreditCard;
    override ngOnInit(): void {
        this.lastOrder = this.customer.history.orders?.[0];
        this.customerName = [this.customer.model.data.prefix, this.customer.model.data.firstname, this.customer.model.data.lastname].join(
            ' '
        );
        this.firstAddress =
            this.customer.addressBook.shipping || this.customer.addressBook.billing || this.customer.addressBook.addresses?.[0];
        this.defaultCard = this.getDefaultCard();
        this.subscriptions.add(this.customer.history.subscribe(() => this.detectChanges()));
        super.ngOnInit();
    }
    override ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
    get email(): string {
        return this.customer.model.data.email;
    }
    private getDefaultCard(): CreditCard | undefined {
        if (!this.customer.model.cards?.length) {
            return undefined;
        }
        const defaultCards = this.customer.model.cards.filter(card => !!card.data.is_default);
        return defaultCards[0] || this.customer.model.cards[0];
    }
    isCardExpired(date: string): boolean {
        return isCardExpired(date);
    }
}
